<script setup>
import { useToggle } from '@vueuse/core'
import { useMessageStack } from '@provise/stores/messagestack'
import { transformer } from '@provise/lib/transformer'
import { useApi } from '@provise/composables/api'
import Mod from '@provise/components/mod.vue'
import Create from './create.vue'
import { computed, inject, ref } from 'vue'
import { replyMapping, REPLY_STATES } from '../../item.vue'

const model = defineModel()
const emit = defineEmits(['deleted', 'edited'])
const complaint = inject('complaint', () => ref({}), true)

const editmod = ref(null)

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  disableCheckbox: {
    type: Boolean,
    default: true,
  },
})

const { push: notify } = useMessageStack()
const [ed, toggleEd] = useToggle(false)
const transform = transformer(['comment', 'name', ['doc_template', 'id'], 'doc_text'])
const isGenerated = computed(() => model.value.name && model.value.name.length)
const url = `complaints/${complaint.value.id}/reply/${model.value.id}`
const { refresh: remove } = useApi({
  url,
  method: 'delete',
})
const { refresh: save } = useApi({
  url,
  model,
  method: 'put',
  transform,
})
async function rm() {
  if (!confirm('Подтвердите удаление')) return
  await remove()
  notify('Ответ удалён')
  emit('deleted')
}
async function sv() {
  await save()
  if (!isGenerated.value) {
    notify('Комментарий к ответу сохранён')
  }
  model.value = replyMapping(complaint)(model.value)
  emit('edited')

  if (isGenerated.value) {
    editmod.value.hide()
  } else {
    toggleEd(false)
  }
}

async function throwOnCoordination() {
  if (model.value.id) {
    if (!model.value.doc_template && model.value.aligned != null) {
      notify('Файлы не могу повторно отправляться на согласование')
      return
    }
    await useApi({
      url: `complaints/${model.value.complaint.id}/reply/${model.value.id}/start_approve`,
    }).refresh()
    emit('edited')
    notify('Ответ отправлен на согласование')
  }
}
</script>
<template>
  <div>
    <form class="hstack gap-3" @submit.prevent="sv">
      <div class="btn btn-success disabled" v-if="model.get_state === REPLY_STATES.STATE_DONE">
        <i class="bi bi-check-square" />
      </div>
      <div class="btn btn-danger disabled" v-if="model.get_state === REPLY_STATES.STATE_DENY">
        <i class="bi bi-x-square" />
      </div>
      <div class="btn btn-warning disabled" v-if="model.get_state === REPLY_STATES.STATE_WAIT">
        <i class="bi bi-square" />
      </div>
      <div
        class="btn btn-warning disabled"
        v-if="model.get_state === REPLY_STATES.STATE_WAIT_COMMERCE"
      >
        <i class="bi bi-check-square" />
      </div>
      <div
        class="btn btn-outline-blue"
        :class="{ disabled: disableCheckbox }"
        v-if="model.get_state === REPLY_STATES.STATE_PREPARE"
        @click="throwOnCoordination()"
      >
        <i class="bi bi-check-square" />
      </div>

      <div class="col-5">
        <div class="form-control disabled" v-if="!model.link">{{ model.display_name }}</div>
        <a v-else download :href="model.link" class="form-control disabled">
          {{ model.display_name }}
        </a>
      </div>

      <button
        type="button"
        class="btn btn-success"
        @click="toggleEd(true)"
        v-if="!ed"
        :disabled="model.get_state === REPLY_STATES.STATE_DONE || disabled"
      >
        <i class="bi bi-pencil" />
      </button>
      <button type="submit" class="btn btn-success" v-if="ed" :disabled="disabled">
        <i class="bi bi-check" />
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        @click="rm"
        :disabled="model.get_state === REPLY_STATES.STATE_DONE || disabled"
      >
        <i class="bi bi-trash-fill" />
      </button>
      <template v-if="ed && !isGenerated">
        Комментарий:
        <input type="text" class="form-control" v-model="model.comment" />
      </template>

      <template v-else>
        <span class="text-muted small fst-italic" v-if="!model.comment">
          Комментарий отсутствует
        </span>
        <span class="text-muted small" v-else>
          <i class="bi bi-chat-left-text me-1" />
          {{ model.comment }}
        </span>
      </template>
    </form>
    <span
      class="text-muted small"
      v-if="model.approval_comment_label"
      v-html="model.approval_comment_label"
    />
  </div>
  <Mod v-if="isGenerated && ed" @hidden="toggleEd(false)" ref="editmod">
    <template #header>Редактируем ответ</template>
    <Create v-model="model" :api-fn="sv" />
  </Mod>
</template>
